import React, { useEffect, useState } from "react";
import MaintenanceImg from "../../../assets/images/maintenance.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FiRefreshCw } from "react-icons/fi";
import axios from "axios";

const Maintenance = ({ setIsMaintenance }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(false);
  const [maintenanceData, setMaintenanceData] = useState(null);

  const fetchStatus = async () => {
    setIsChecking(true);
    try {
      const response = await axios.get(
        `${window.WEB_APP_API_URL}/auth/maintenance-status`,
      );
      setMaintenanceData(response.data);
      if (response.data && !response.data.isMaintenanceMode) {
        if (setIsMaintenance) {
          setIsMaintenance(false);
        }
        navigate("/", { replace: true });
      }
    } catch (error) {
      console.error("Error fetching maintenance status:", error);
    } finally {
      setIsChecking(false);
    }
  };

  // UNDER MAINTENANCE LOGIC TEMPORARILY DISABLED (disabled repeated API calls)
  // useEffect(() => {
  //   fetchStatus();
  //   const interval = setInterval(fetchStatus, 30000);
  //   return () => clearInterval(interval);
  // }, []);

  return (
    <div className="w-full h-screen bg-white flex flex-col justify-center items-center p-4">
      <div className="max-w-2xl w-full text-center space-y-6 animate-in fade-in zoom-in duration-700">
        <div className="relative inline-block">
          <img
            src={MaintenanceImg}
            alt="Maintenance Illustration"
            className="w-full max-w-sm mx-auto h-72 object-contain drop-shadow-2xl"
          />
          <div className="absolute -top-4 -right-4 bg-amber-500 text-white px-4 py-1 rounded-full text-sm font-bold shadow-lg animate-bounce">
            {t("Scheduled")}
          </div>
        </div>

        <div className="space-y-4">
          <h2 className="text-3xl md:text-5xl font-extrabold text-slate-800 tracking-tight">
            {t("Under Maintenance")}
          </h2>
          <p className="text-lg md:text-xl text-slate-500 max-w-lg mx-auto leading-relaxed">
            {t(
              "We are currently performing some scheduled maintenance to improve your experience. We'll be back shortly!",
            )}
          </p>
        </div>

        <div className="flex flex-col items-center space-y-4">
          <div className="inline-flex items-center space-x-2 text-slate-400 text-sm font-medium uppercase tracking-widest">
            <span className="relative flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-amber-500"></span>
            </span>
            <span>{t("System Update in Progress")}</span>
          </div>

          <button
            onClick={fetchStatus}
            disabled={isChecking}
            className="flex items-center space-x-2 px-6 py-2 bg-slate-100 hover:bg-slate-200 text-slate-600 rounded-full transition-all duration-200 disabled:opacity-50"
          >
            <FiRefreshCw className={`w-4 h-4 ${isChecking ? "animate-spin" : ""}`} />
            <span>{isChecking ? t("Checking...") : t("Refresh Status")}</span>
          </button>
        </div>

        <div className="pt-8 border-t border-slate-100">
          <p className="text-slate-400 text-sm">
            &copy; {new Date().getFullYear()} NuTrade.{" "}
            {t("All rights reserved.")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
